import { ROUTES } from '@/routes/paths';

const SIGNIN_REDIRECT_URL = `${ROUTES.signin}?ctab=init`;
const LEGACY_SIGNIN_PATH = ROUTES.legacySignin;
const MOBILE_MEMBERSHIP_MOCK_STORAGE_KEY = 'mobileMembershipMockScenario';
const MOBILE_MEMBERSHIP_MOCK_QUERY_KEY = 'mock';
const MOBILE_MEMBERSHIP_MOCK_LIVE_HOSTNAME = 'app.sellerbox.io';
const MOBILE_MEMBERSHIP_MOCK_ALLOWED_HOSTNAMES = new Set(['localhost', 'app-dev.sellerbox.io']);
const MOBILE_MEMBERSHIP_MOCK_SCENARIOS = new Set([
  'earlybird',
  'app-conversion',
  'app-conversion-pending',
  'web-subscriber',
]);

let isUnauthorizedRedirecting = false;

export const handleUnauthorizedStatus = (status?: number) => {
  if (status !== 401) {
    return false;
  }

  if (typeof window === 'undefined') {
    return true;
  }

  const { pathname, search } = window.location;
  const searchParams = new URLSearchParams(search);
  const redirectPath = searchParams.get('redirect') ?? '';
  const redirectSearch = redirectPath.includes('?') ? redirectPath.split('?')[1] : '';
  const redirectParams = new URLSearchParams(redirectSearch);
  const normalizedHostname = window.location.hostname.toLowerCase();
  const isAllowedMobileMembershipMockHostname =
    normalizedHostname !== MOBILE_MEMBERSHIP_MOCK_LIVE_HOSTNAME &&
    MOBILE_MEMBERSHIP_MOCK_ALLOWED_HOSTNAMES.has(normalizedHostname);
  const isMobileMembershipMockRoute =
    isAllowedMobileMembershipMockHostname &&
    pathname.startsWith(`${ROUTES.mobileRoot}/`) &&
    (MOBILE_MEMBERSHIP_MOCK_SCENARIOS.has(
      localStorage.getItem(MOBILE_MEMBERSHIP_MOCK_STORAGE_KEY) ?? '',
    ) ||
      MOBILE_MEMBERSHIP_MOCK_SCENARIOS.has(
        searchParams.get(MOBILE_MEMBERSHIP_MOCK_QUERY_KEY) ?? '',
      ) ||
      MOBILE_MEMBERSHIP_MOCK_SCENARIOS.has(
        redirectParams.get(MOBILE_MEMBERSHIP_MOCK_QUERY_KEY) ?? '',
      ));

  if (isMobileMembershipMockRoute) {
    return true;
  }

  localStorage.removeItem('cplatToken');

  if (isUnauthorizedRedirecting) {
    return true;
  }

  const isSigninPage =
    pathname.startsWith(ROUTES.signin) || pathname.startsWith(LEGACY_SIGNIN_PATH);
  const isAlreadyRedirectedSignin = pathname.startsWith(ROUTES.signin) && search.includes('ctab=');

  if (isSigninPage || isAlreadyRedirectedSignin) {
    return true;
  }

  isUnauthorizedRedirecting = true;
  window.location.replace(SIGNIN_REDIRECT_URL);
  return true;
};
